import React, { Component } from 'react'
import SVG from 'react-inlinesvg'
import arrow from '@icons/arrow-right-white'
import { defaultSubjectPath } from '@app/components/ui/buttons/PlatformLink'
import _ from 'lodash'

class BonusTaskOfPreparatory extends Component {
  render() {
    if (window.COUNTRY === 'CN' || window.COUNTRY === 'ZA') { return null }

    let params = {redirect: 'recommended_card'}

    if (window.COUNTRY === 'IN') {
      const { student } = this.props
      if (student.grade >= 7) { return null }

      params = Object.assign(params, {
        utm_source: 'bricsmath',
        utm_medium: 'trunk',
        utm_campaign: 'brics_prep_2021'
      })
    }

    const { statistics } = this.props;
    const objects = _.values(statistics.objects);

    if (!_.some(statistics.objects, 'answer')) { return false }

    const count = objects.filter(value => value && value.answer && value.answer.score > 0).length;

    if (count < objects.length) { return null }

    return (
      <div className="bonus-task">
        <div className="bonus-task__row">
          <div className="bonus-task__icon" />
          <p className="bonus-task__text">
            { I18n.t("students.bonus_task.text") }
          </p>
        </div>
        <div className="bonus-task__row">
          <a
            href={ defaultSubjectPath() }
            target="_blank"
            className="btn btn--red btn--icon-right bonus-task__link">

            { I18n.t("js.students_table.solve") }
            <SVG src={arrow} />
          </a>
        </div>
      </div>
    )
  }
}

export default BonusTaskOfPreparatory
